<template>
  <a :href="channel.url"
     class="bx-epg-channel">
    <figure v-if="channelLogoUrl">
      <img :src="channelLogoUrl"
           :alt="`${channel.logo.imageAltText} Logo`"
           :title="channel.logo.imageAltText"
           :width="channel.logo.width"
           :height="channel.logo.height"
           loading="lazy">
    </figure>
    <span>{{ channel.name }}</span>
    <!-- TODO enable channel name on the right instead of below: [LOGO] NAME - for epg autocomplete search in header -->
  </a>
</template>

<script>
import { mapState } from 'pinia'

import { useConfigStore } from '../../../../stores/config'
import { usePageStore } from '../../../../stores/page'
import imgSrcSet from '../../../../mixins/img-src-set'

export default {
  components: {

  },
  mixins: [imgSrcSet],
  props: {
    channel: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    // this store prop is only used by a mixin
    ...mapState(useConfigStore, ['rsConfig']),
    ...mapState(usePageStore, ['brandFromStore']),
    channelLogoUrl () {
      return this.channel?.logo
        ? this.createImgSrc({
          image: this.channel.logo,
          brand: this.brandFromStore,
          type: 'webp',
          setName: 'channelLogo'
        })
        : null
    }
  }
}
</script>
